export enum Radius {
  S = 4,
  M = 8,
  L = 12,
}
